import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    redirect: '/howto/'
  },
  {
    path: '/howto',
    name: 'HowTo-root',
    component: () => import('../views/HowTo.vue')
  },
  {
    path: '/howto/:section',
    name: 'HowTo-detail',
    component: () => import('../views/HowTo.vue'),
    meta: {
      title: '华卡音舞'
    }
  },
  {
    path: '/location',
    name: 'Location',
    component: () => import('../views/Location.vue'),
    meta: {
      title: '机台分布'
    }
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: () => import('../views/Gallery.vue'),
    meta: {
      title: '四格漫画'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
